<template>
    <ul role="list" class="bg-white">
        <slot />
    </ul>
</template>
